import * as React from 'react';
import { compose, withHandlers } from 'recompose';
import { ReportType } from 'types';
import { ColumnPositionControl } from './ColumnPositionControl';
import { TableColumn } from 'logic/reports/ReportSettings';
import { getTextKeyForColumn } from 'logic/reports/getTextKeyForColumn';
import { showColumn, hideColumn, moveColumn } from 'logic/reports/tableColumns';

import './ColumnPositionControlList.css';

type OwnProps = {
    reportType: ReportType;
    columns: ReadonlyArray<TableColumn>;
    onChange: (columns: ReadonlyArray<TableColumn>) => void;
};

const RawColumnPositionControlList = ({ reportType, columns, handleCheckChanged, handlePositionChanged, onChange }: RecomposeProps & OwnProps) =>
    <div
        className="column-position-control-list"
    >
        { columns.map((c, i) =>
            <ColumnPositionControl
                key={ c.name }
                index={ i }
                max={ columns.length }
                checked={ typeof c.visibleIndex === 'number' }
                textKey={ getTextKeyForColumn(reportType, c.name) }
                position={ c.visibleIndex }
                onCheckChanged={ handleCheckChanged }
                onPositionChanged={ handlePositionChanged }
            />
        ) }
    </div>
;

type RecomposeProps = {
    handleCheckChanged: (i: number, check: boolean) => void;
    handlePositionChanged: (i: number, position: number) => void;
};

export const ColumnPositionControlList = compose<RecomposeProps & OwnProps, OwnProps>(
    withHandlers<OwnProps, RecomposeProps>({
        handleCheckChanged: ({ columns, onChange }) => (i: number, check: boolean) => {
            columns = check ? showColumn(columns, i) : hideColumn(columns, i);
            onChange(columns);
        },
        handlePositionChanged: ({ columns, onChange }) => (i: number, position: number) => {
            columns = moveColumn(columns, i, position);
            onChange(columns);
        },
    }),
)(RawColumnPositionControlList);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/tableLayout/ColumnPositionControlList.tsx